import { render, staticRenderFns } from "./MarketOrderCreated.vue?vue&type=template&id=006eda1f&"
import script from "./MarketOrderCreated.vue?vue&type=script&lang=js&"
export * from "./MarketOrderCreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports